import React, { useState, useEffect } from "react";
import "./AddCourtPopup.css"; // reuse popup styles

export default function AddChamberPopup({ onAddChamber }) {
  const [showPopup, setShowPopup] = useState(false);
  const [courts, setCourts] = useState([]); // list of courts
  const [newChamber, setNewChamber] = useState({
    courtId: "",
    chamberName: "",
    judgeName: "",
  });

  // Fetch courts when popup opens
  useEffect(() => {
    if (showPopup) {
      const fetchCourts = async () => {
        try {
          const token = localStorage.getItem("token");
          const res = await fetch("http://localhost:5272/api/CourtMaster/GetCourt", {
            headers: { Authorization: `Bearer ${token}` },
          });

          if (res.ok) {
            const data = await res.json();
            setCourts(data);
          } else {
            console.error("Failed to fetch courts");
          }
        } catch (err) {
          console.error("Error fetching courts:", err);
        }
      };
      fetchCourts();
    }
  }, [showPopup]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Send courtId, not courtName
    await onAddChamber(newChamber);

    // reset form
    setNewChamber({ courtId: "", chamberName: "", judgeName: "" });
    setShowPopup(false);
  };

  return (
    <div>
      {/* Button to open popup */}
      <button onClick={() => setShowPopup(true)}>Add Chamber</button>

      {/* Popup */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-container">
            <h2 className="popup-title">Add Chamber</h2>
            <form onSubmit={handleSubmit} className="popup-form">
              {/* Dropdown for court selection */}
              <select
                value={newChamber.courtId}
                onChange={(e) =>
                setNewChamber({ ...newChamber, courtId: e.target.value })
                }
                required
                className="popup-select"
                >
                <option value="">-- Select Court --</option>
                {courts.map((court) => (
                <option key={court.courtId} value={court.courtId}>
                    {court.courtName} ({court.city})
                </option>))}
                </select>

              {/* Chamber Name */}
              <input
                type="text"
                placeholder="Chamber Name"
                value={newChamber.chamberName}
                onChange={(e) =>
                  setNewChamber({ ...newChamber, chamberName: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
                className="popup-select"
              />

              {/* Judge Name */}
              <input
                type="text"
                placeholder="Judge Name"
                value={newChamber.judgeName}
                onChange={(e) =>
                  setNewChamber({ ...newChamber, judgeName: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
                className="popup-select"
              />

              <div className="popup-buttons">
                <button type="submit" className="btn-save">Save</button>
                <button
                  type="button"
                  className="btn-cancel"
                  onClick={() => setShowPopup(false)}
                  style={{ marginLeft: "10px" }}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
